/**
 * 用于存储app的各种全局状态,如:
 * > 当前是否正在进行路由切换(以用于显示一个加载的效果)
 * > 下一个页面切换的方向(用以实现页面切换动画)
 * > 列表页面的滚动条位置等
 */
import {
  ROUTE_SWITCHING, SET_APPOINTMENT_LIST_TAB_INDEX, SET_APPOINTMENT_PAY_TAB_INDEX,
  SET_EM_APPOINTMENT_LIST_TAB_INDEX, SET_SPECIAL_CLINIC_SCHEDULE_TAB_INDEX, SET_ACTIVITY_TAB_INDEX,
  SET_INOUT_HOSPITAL_SCHEDULE_TAB_INDEX, SET_ORDER_LIST_TAB_INDEX, SET_NAD_TAB_INDEX,
  SET_PRETTY_TIBET_LIST_TAB_INDEX, SET_MAIL_APPLICATION_TAB_INDEX, DEBUG_MODE, SET_ORDER_SIGN_TAB_INDEX,
  FIRST_MENU, SET_FF_PATIENT, SET_PRE_DIAGNOSIS_TAB_INDEX
} from '../mutation-types'

const state = {
  isSwitching: false,   // 路由正在切换...
  apListTabIndex: 1,
  apPayTabIndex: 1,
  emApListTabIndex: 1,
  specialClinicTabIndex: 1,
  inoutHospitalClinicTabIndex: 1,
  activityTabIndex: 1,
  mesOrderListTabIndex: 1,
  prettyTibetListTabIndex: 1,
  mailApplicationTabIndex: 1,
  orderSignTabIndex: 1,
  preDiagnosisTabIndex: 1,
  debugMode: false,
  firstMenu: true
}

const mutations = {
  [ROUTE_SWITCHING] (state, isSwitching) {
    state.isSwitching = isSwitching
  },

  [SET_APPOINTMENT_LIST_TAB_INDEX] (state, index) {
    state.apListTabIndex = index
  },

  [SET_APPOINTMENT_PAY_TAB_INDEX] (state, index) {
    state.apPayTabIndex = index
  },

  [SET_EM_APPOINTMENT_LIST_TAB_INDEX] (state, index) {
    state.emApListTabIndex = index
  },

  [SET_SPECIAL_CLINIC_SCHEDULE_TAB_INDEX] (state, index) {
    state.specialClinicTabIndex = index
  },

  [SET_INOUT_HOSPITAL_SCHEDULE_TAB_INDEX] (state, index) {
    state.inoutHospitalClinicTabIndex = index
  },

  [SET_ACTIVITY_TAB_INDEX] (state, index) {
    state.activityTabIndex = index
  },

  [SET_NAD_TAB_INDEX] (state, index) {
    state.nadTabIndex = index
  },

  [SET_ORDER_LIST_TAB_INDEX] (state, index) {
    state.mesOrderListTabIndex = index
  },

  [SET_PRETTY_TIBET_LIST_TAB_INDEX] (state, index) {
    state.prettyTibetListTabIndex = index
  },

  [FIRST_MENU] (state, isFirst) {
    state.firstMenu = isFirst
  },

  [SET_MAIL_APPLICATION_TAB_INDEX] (state, index) {
    state.mailApplicationTabIndex = index
  },

  [DEBUG_MODE] (state, index) {
    state.debugMode = index
  },

  [SET_ORDER_SIGN_TAB_INDEX] (state, index) {
    state.orderSignTabIndex = index
  },

  [SET_FF_PATIENT] (state, index) {
    state.defaultFFPatientId = index
  },

  [SET_PRE_DIAGNOSIS_TAB_INDEX] (state, index) {
    state.preDiagnosisTabIndex = index
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js